export default __webpack_public_path__ + "328953c.png";